import { Slot } from 'expo-router';

export default function OnboardingLayout(): React.ReactNode {
  return <Slot />;
}
